import { useState, useCallback } from "react";

/**
 * data: 체크 대상 배열
 * getKey: 각 항목의 고유 식별자를 추출하는 함수 (default: item.id)
 */
export function useCheckBoxGroup(data = [], getKey = (item) => item.id) {
  const [checkedItems, setCheckedItems] = useState([]);

  // 전체 항목들의 고유 키 목록
  const allKeys = data.map(getKey);

  // 전체 선택 여부
  const isAllChecked =
    allKeys.length > 0 && allKeys.every((key) => checkedItems.includes(key));

  // 개별 토글
  const handleToggleItem = useCallback((key) => {
    setCheckedItems((prev) => {
      return prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key];
    });
  }, []);

  // 전체 토글
  const handleToggleAll = useCallback(() => {
    setCheckedItems((prev) => {
      return isAllChecked ? [] : allKeys;
    });
  }, [isAllChecked, allKeys]);

  return {
    checkedItems,
    setCheckedItems,
    isAllChecked,
    handleToggleItem,
    handleToggleAll,
  };
}
